module.exports = __webpack_public_path__ + "img/discover.5b494cf4.jpg";